import { BaseApiService } from '@doccareplus/api-client';

// HTTP adapter for the patient-portal billing endpoints (api/portal/billing/*). Auth is by
// PatientPortalLink ownership — the requesting user + active link are resolved server-side from the JWT and
// the X-Portal-Link-Id header (applied globally, see profiles' `applyActiveProfileHeader`), never sent
// per-request here. All JSON is camelCase; these types mirror the C# Contracts.Portal.Billing records 1:1.
//
// V1 has no online payment (see .ai/BusinessDomain/billing-payment.md, "Patient Portal Visibility") — this
// service is read-only by design; there is no pay/checkout method to add here.

/** Mirrors Contracts.Portal.Billing.PortalInvoiceDto. Draft/Void invoices never appear here. */
export interface PortalInvoiceDto {
  id: string;
  invoiceNumber: string;
  status: 'Issued' | 'PartiallyPaid' | 'Paid' | 'Overdue';
  invoiceDate: string;
  dueDate: string | null;
  total: number;
  paidAmount: number;
  balance: number;
  currency: string;
}

export interface MyInvoicesResponse {
  currency: string;
  outstandingBalance: number;
  invoices: PortalInvoiceDto[];
}

class BillingApiService extends BaseApiService {
  constructor() {
    super('/portal');
  }

  listInvoices(): Promise<MyInvoicesResponse> {
    return this.get<MyInvoicesResponse>('/billing/invoices');
  }
}

export const billingApi = new BillingApiService();
